var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPointsRecoup = function SvgPointsRecoup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 230,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#points-recoup_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#points-recoup_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.466 144.29S80.722 100.934 74.291 93c-9.984-9.5-26.03-14.69-32.276-1.974-4.057 8.252 3.17 15.199 9.455 20.026 7.17 5.508 11.34 15.676 28.418 64.604",
    fill: "#FFB4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.466 144.29S80.722 100.934 74.291 93c-9.984-9.5-26.03-14.69-32.276-1.974-4.057 8.252 3.17 15.199 9.455 20.026 7.17 5.508 11.34 15.676 28.418 64.604",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.965 178.839s-19.65-50.423-18.682-57.504c.974-7.125 19.695-21.433 24.445-17.428 15.473 13.06 30.372 33.264 30.372 33.264",
    fill: "#FFE4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.965 178.839s-19.65-50.423-18.682-57.504c.974-7.125 19.695-21.433 24.445-17.428 15.473 13.06 30.372 33.264 30.372 33.264",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.201 96.515c-3.145-3.827-5.832-8.513-8.545-10.698-3.177-2.56-12.64-2.317-13.314 4.859-.408 4.31 1.063 11.162 12.836 8.71",
    fill: "#FFB4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.201 96.515c-3.145-3.827-5.832-8.513-8.545-10.698-3.177-2.56-12.64-2.317-13.314 4.859-.408 4.31 1.063 11.162 12.836 8.71",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.208 208.04c-5.298-25.227-22.178-38.198-22.178-38.198-9.29-6.921-27.24 21.439-10.595 41.49",
    fill: "#FFE4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.208 208.04c-5.298-25.227-22.178-38.198-22.178-38.198-9.29-6.921-27.24 21.439-10.595 41.49",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.1 197.439c14.158 0 25.636-11.478 25.636-25.636s-11.478-25.635-25.636-25.635-25.635 11.477-25.635 25.635c0 14.158 11.477 25.636 25.635 25.636Z",
    fill: "#FFE4D9",
    stroke: "#000",
    strokeWidth: 3.483,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.812 164.029s-7.647 14.861-10.117 29.627",
    stroke: "#000",
    strokeWidth: 2.611,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.871 180.291c3.853-9.061 10.354-13.569 10.354-13.569l16.039 4.209c-17.274 14.187-17.408 62.127-17.408 62.127h-77.55c3.758-40.503 15.009-66.552 24.159-81.618l13.04 4.699s-5.055 10.742-6.01 13.729c-1.847 5.788-1.172 12.111 12.48 15.052 18.816 4.056 22.203 1.7 24.896-4.629Z",
    fill: "#2E2828",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.253 161.424-11.939-1.496c-3.635-.458-6.705 2.681-6.17 6.304l.51 3.451c.515 3.489 4.113 5.61 7.418 4.374l9.971-3.731",
    fill: "#EA4C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.253 161.424-11.939-1.496c-3.635-.458-6.705 2.681-6.17 6.304l.51 3.451c.515 3.489 4.113 5.61 7.418 4.374l9.971-3.731",
    stroke: "#000",
    strokeWidth: 3.483,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.126 166.792s-6.361-3.445-11.08 2.05",
    stroke: "#000",
    strokeWidth: 2.611,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.302 163.22 11.175 4.47c3.4 1.363 4.565 5.591 2.343 8.5l-2.114 2.77c-2.139 2.802-6.316 2.917-8.609.242l-6.921-8.093",
    fill: "#EA4C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.302 163.22 11.175 4.47c3.4 1.363 4.565 5.591 2.343 8.5l-2.114 2.77c-2.139 2.802-6.316 2.917-8.609.242l-6.921-8.093",
    stroke: "#000",
    strokeWidth: 3.483,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.812 167.983s7.24.064 8.705 7.157",
    stroke: "#000",
    strokeWidth: 2.611,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.775 174.853a7.246 7.246 0 1 0 0-14.492 7.246 7.246 0 0 0 0 14.492Z",
    fill: "#EA4C53",
    stroke: "#000",
    strokeWidth: 3.483,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m79.9 205.901 45.35 8.029c-6.228 26.903-50.946 26.514-45.35-8.029Z",
    fill: "#2E2828",
    stroke: "#000",
    strokeWidth: 1.738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.683 193.211a.33.33 0 0 0-.261.152l-.038-.025c-.064.121-.019.287.146.382.866.516 2.344 1.057 4.063 1.445 1.719.389 3.292.535 4.298.446.191-.019.293-.146.293-.28h-.045c0-.089-.057-.185-.172-.248-.859-.516-2.324-1.051-4.024-1.439-1.706-.389-3.26-.529-4.26-.44v.007Zm9.443 1.636c.096-.669-2.088-1.719-4.922-2.362-2.833-.643-5.253-.637-5.463.006h-.006a16.713 16.713 0 0 0-2.382 4.693 22.936 22.936 0 0 0 12.901 2.923 16.827 16.827 0 0 0-.121-5.266h-.007v.006Zm-8.481 13.333c2.871.65 4.845.325 5.552-.369a16.457 16.457 0 0 0 2.063-3.808 22.949 22.949 0 0 1-12.684-2.871 16.513 16.513 0 0 0 .223 4.33c.134.783 1.98 2.075 4.852 2.725l-.006-.007Z",
    fill: "#7F6C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.741 233.058h-50.742c-3.553 0-6.158-2.324-6.565-6.017-.134-1.777.134-4.375.955-6.017 2.872-6.291 10.806-7.66 16.549-8.068l29.679-10.665",
    fill: "#FFB4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.741 233.058h-50.742c-3.553 0-6.158-2.324-6.565-6.017-.134-1.777.134-4.375.955-6.017 2.872-6.291 10.806-7.66 16.549-8.068l29.679-10.665",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.215 202.284s-25.686-.21-22.159 6.565c1.917 6.157 5.062 13.951 3.146 24.209h29.405c6.017 0 17.427-1.331 11.028-27.488",
    fill: "#FFE4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.215 202.284s-25.686-.21-22.159 6.565c1.917 6.157 5.062 13.951 3.146 24.209h29.405c6.017 0 17.427-1.331 11.028-27.488",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.652 132.822s8.831-23.502 26.068-25.916M138.742 203.526s6.705 7.526 5.712 28.717",
    stroke: "#000",
    strokeWidth: 2.611,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.776 95.324c3.012-7.386 6.565-14.085 8.208-17.37.821-1.503.274-3.42-1.229-4.241-.407-.134-.821-.274-1.095-.407-1.229-.408-2.738.133-3.419 1.368-2.872 4.649-8.068 15.18-10.392 19.835 3.827.408 7.112.822 7.934.822l-.007-.007Z",
    fill: "#2E2828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.705 73.305c.274 0 .548 0 .821.134.408.134.682.274 1.096.408 1.502.821 2.05 2.738 1.228 4.24-1.776 3.146-5.195 9.85-8.207 17.37-.681-.133-3.967-.547-7.934-.82 2.324-4.649 7.52-15.18 10.392-19.835.681-.955 1.642-1.503 2.598-1.503l.006.006Zm0-4.1c-2.464 0-4.788 1.229-6.017 3.42-2.872 4.647-7.934 14.632-10.532 20.241-.548 1.23-.548 2.598.134 3.827.681 1.229 1.916 1.917 3.285 2.05 3.827.274 6.973.682 7.66.822h.548c1.643 0 3.145-.955 3.827-2.598 3.285-8.068 6.972-14.906 8.067-16.963.955-1.776 1.095-3.827.548-5.743-.548-1.917-1.917-3.42-3.693-4.241-.548-.274-1.229-.548-1.777-.681-.681-.14-1.369-.14-2.05-.14v.006Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.044 81.24-.408-.408c-.821-.548-1.776-.681-2.738-.274-6.565 3.693-15.594 14.225-19.287 18.6 2.19.547 4.241 1.095 6.565 1.776 6.291-7.934 12.448-13.27 15.868-15.868 1.228-.955 1.228-2.871 0-3.827Z",
    fill: "#2E2828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.993 80.284c.548 0 1.095.134 1.503.548l.407.407c1.369.956 1.369 2.872 0 3.967-3.419 2.738-9.576 7.934-15.867 15.868a164.402 164.402 0 0 0-6.565-1.777c3.693-4.374 12.722-15.046 19.287-18.599.407-.274.821-.407 1.229-.407l.006-.007Zm0-4.1c-1.095 0-2.19.273-3.145.821-6.973 3.827-15.868 13.951-20.383 19.56-.955 1.096-1.095 2.599-.681 3.828.408 1.369 1.503 2.324 2.872 2.738h.134c2.19.547 4.1 1.095 6.291 1.776.407.134.821.134 1.229.134a4.087 4.087 0 0 0 3.285-1.643c4.515-5.743 9.577-10.805 15.18-15.18 1.643-1.229 2.464-3.145 2.464-5.196 0-2.05-.955-3.967-2.598-5.196l-.407-.407c-1.369-.681-2.738-1.229-4.241-1.229v-.006Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.124 160.418c-10.022 0-18.179-8.156-18.179-18.179 0-10.022 8.157-18.179 18.18-18.179 10.022 0 18.178 8.157 18.178 18.179 0 10.023-8.156 18.179-18.179 18.179Zm0-26.807c-4.756 0-8.627 3.872-8.627 8.628 0 4.757 3.954 8.628 8.627 8.628 4.674 0 8.628-3.954 8.628-8.628 0-4.673-3.871-8.628-8.628-8.628Z",
    fill: "#E64257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.124 126.238a15.935 15.935 0 0 1 16.002 16.001c0 8.889-7.247 16.002-16.002 16.002-8.755 0-16.001-7.113-16.001-16.002a15.935 15.935 0 0 1 16.001-16.001Zm0 26.807c5.884 0 10.806-4.922 10.806-10.806 0-5.883-4.789-10.805-10.806-10.805-6.017 0-10.805 4.922-10.805 10.805 0 5.884 4.922 10.806 10.805 10.806Zm0-31.162c-11.226 0-20.356 9.131-20.356 20.356 0 11.226 9.13 20.357 20.356 20.357s20.357-9.131 20.357-20.357c0-5.463-2.108-10.582-5.941-14.416-3.833-3.833-8.953-5.94-14.416-5.94Zm0 26.807c-3.496 0-6.45-2.955-6.45-6.451 0-3.495 2.897-6.45 6.45-6.45 3.553 0 6.45 2.897 6.45 6.45 0 3.553-2.954 6.451-6.45 6.451Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.222 106.403c21.745 8.756 16.689 56.626 2.324 65.241-12.034 7.113-28.997 1.917-52.658-3.145-23.662-5.062-43.356-11.213-44.044-28.176-.681-15.594 13.951-43.356 31.729-45.406 19.835-2.465 49.647 5.743 62.643 11.486h.006Z",
    fill: "#FFB4B6",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4 144.29a10.743 10.743 0 0 0 10.805-10.806 10.742 10.742 0 0 0-10.806-10.805 10.742 10.742 0 0 0-10.805 10.805 10.743 10.743 0 0 0 10.805 10.806ZM141.175 155.643c5.883 0 10.805-4.789 10.805-10.806a10.742 10.742 0 0 0-10.805-10.805 10.742 10.742 0 0 0-10.806 10.805 10.743 10.743 0 0 0 10.806 10.806Z",
    fill: "#FF7399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.284 111.058s-6.291 7.934-11.76 22.019l11.76-22.019Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.517 137.177c-.547 0-.955-.133-1.502-.274a4.146 4.146 0 0 1-2.325-5.335c5.61-14.499 12.035-22.707 12.309-23.114 1.369-1.777 3.967-2.051 5.743-.682 1.777 1.369 2.05 3.967.681 5.744-.133.134-6.017 7.794-11.079 20.923-.681 1.777-2.19 2.738-3.827 2.738ZM141.308 118.304s-6.565 13.811-10.124 22.706l10.124-22.706Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.191 145.111c-.548 0-.956-.134-1.503-.274-2.05-.821-3.146-3.285-2.324-5.336 3.553-9.029 9.984-22.432 10.258-22.98.955-2.05 3.419-2.871 5.469-1.916 2.051.955 2.872 3.419 1.917 5.469-.134.134-6.565 13.811-10.124 22.433-.548 1.643-2.051 2.598-3.693 2.598v.006Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.107 54.98c5.196-13.677 18.325-20.382 30.5-16.823 12.174 3.553 19.561 15.454 16.275 26.674-3.286 11.212-9.85 23.935-29.271 18.325-19.968-5.884-21.611-17.37-17.504-28.176Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.042 39.252c-9.436 0-18.051 6.291-21.885 16.416-2.19 5.743-2.19 10.532-.273 14.498 2.464 4.789 7.933 8.482 16.415 10.94 17.918 5.196 23.661-6.291 26.807-16.823 2.871-10.124-3.693-20.924-14.906-24.069a20.583 20.583 0 0 0-6.158-.955v-.007Z",
    fill: "#A06437",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.192 90.676c-7.113 10.805-2.738 19.147-8.482 28.723-1.776 3.012.955 6.565 4.375 5.61 4.648-1.503 9.984-4.648 12.722-11.487 9.303-22.292 28.45-19.42 40.21-16.275 4.789 1.229 9.303 5.744 13.404 7.66 8.207 3.827 12.722 12.582 11.486 21.471-.547 3.967-.547 8.341.408 12.582 1.095 5.062.274 9.577-.821 12.722-.822 2.464.955 5.062 3.553 5.062 12.448.408 25.438-6.157 29.952-23.113 2.464-9.163 8.341-48.278-37.479-61.548-40.624-11.627-59.63 3.967-69.341 18.6l.013-.007Z",
    fill: "#A06437",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.528 103.946s3.012 11.353.274 25.304c0 0 14.906-.548 21.197-8.889",
    fill: "#A06437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.528 103.946s3.012 11.353.274 25.304c0 0 14.906-.548 21.197-8.889",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.13 93.962s.821 8.207-1.643 14.224c0 0 12.722 1.503 19.694-6.291",
    fill: "#A06437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.13 93.962s.821 8.207-1.643 14.224c0 0 12.722 1.503 19.694-6.291",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.753 86.435s1.369 11.76 1.228 18.466c0 0 11.08-1.777 17.231-10.258l6.157-2.738",
    fill: "#A06437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.753 86.435s1.369 11.76 1.228 18.466c0 0 11.08-1.777 17.231-10.258l6.157-2.738",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.357 85.34c-4.374 6.017-5.469 19.421 3.012 25.712 0 0 1.917-6.565 8.208-9.984 6.291-3.42 8.481-8.482 8.481-8.482",
    fill: "#A06437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.357 85.34c-4.374 6.017-5.469 19.421 3.012 25.712 0 0 1.917-6.565 8.208-9.984 6.291-3.42 8.481-8.482 8.481-8.482",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.049 59.628c-13.811 3.827-25.578 20.516-31.595 35.836 0 0 16.141-24.343 50.742-25.03 34.601-.681 58.128 26.533 58.81 63.324 0 0 16.141-34.06-9.029-59.631l-68.934-14.499h.006Z",
    fill: "#E64257",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.415 68.243s-.547-13.543-13.951-17.23c-7.386-2.05-15.867.134-22.432-2.324-1.643-.681-3.42.821-3.012 2.464.955 4.241 3.553 10.392 10.124 14.633 14.225 8.755 29.271 2.464 29.271 2.464v-.007Z",
    fill: "#E64257",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.835 73.446c-5.61 6.838-16.549 1.369-14.773-7.246.408-2.19 1.369-4.375 2.872-6.432.134-.133.134-.273.274-.407 5.336-7.386 17.096-2.324 15.18 6.565 0 .133 0 .273-.134.273-.681 3.146-1.917 5.47-3.419 7.247Z",
    fill: "#E64257",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.516 63.869c-3.693 1.369-5.336 5.743-3.286 9.163 2.598 4.24 7.386 9.163 15.868 9.984 10.258 1.095 21.063-4.788 29.405.134 0 0-2.324-13.678-15.32-19.147-10.532-4.375-20.516-2.324-26.674-.134h.007Z",
    fill: "#E64257",
    stroke: "#000",
    strokeWidth: 4.355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.43 185.582c-10.022 0-18.179-8.156-18.179-18.179 0-10.022 8.157-18.179 18.179-18.179 10.022 0 18.179 8.157 18.179 18.179 0 10.023-8.157 18.179-18.179 18.179Zm0-26.806c-4.757 0-8.628 3.871-8.628 8.627 0 4.757 3.954 8.628 8.628 8.628 4.674 0 8.628-3.954 8.628-8.628 0-4.673-3.872-8.627-8.628-8.627Z",
    fill: "#E64257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.43 151.402a15.935 15.935 0 0 1 16.001 16.001c0 8.889-7.246 16.002-16.001 16.002s-16.002-7.113-16.002-16.002a15.936 15.936 0 0 1 16.002-16.001Zm0 26.807c5.883 0 10.805-4.922 10.805-10.806 0-5.883-4.788-10.805-10.805-10.805-6.017 0-10.806 4.922-10.806 10.805 0 5.884 4.922 10.806 10.806 10.806Zm0-31.162c-11.226 0-20.357 9.131-20.357 20.356 0 11.226 9.131 20.357 20.357 20.357 11.226 0 20.356-9.131 20.356-20.357 0-5.463-2.107-10.582-5.94-14.415-3.834-3.834-8.953-5.941-14.416-5.941Zm0 26.807c-3.496 0-6.45-2.955-6.45-6.451 0-3.495 2.897-6.45 6.45-6.45 3.553 0 6.45 2.897 6.45 6.45 0 3.553-2.954 6.451-6.45 6.451Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "points-recoup_svg__c",
    maskUnits: "userSpaceOnUse",
    x: 19.149,
    y: -4.425,
    width: 82.904,
    height: 88.561,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.149-4.425h82.904v88.561H19.149z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m85.897 54.871-.767 2.862a11.867 11.867 0 0 1-8.392 8.392l-18.73 5.019a11.868 11.868 0 0 1-11.463-3.072L32.834 54.361a11.867 11.867 0 0 1-3.072-11.463l.768-2.866 4.251-15.864.768-2.866a11.867 11.867 0 0 1 8.392-8.392l18.73-5.018a11.867 11.867 0 0 1 11.462 3.071l13.712 13.712a11.867 11.867 0 0 1 3.071 11.463l-.767 2.865-4.251 15.865-.001.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m85.897 54.871-.767 2.862a11.867 11.867 0 0 1-8.392 8.392l-18.73 5.019a11.868 11.868 0 0 1-11.463-3.072L32.834 54.361a11.867 11.867 0 0 1-3.072-11.463l.768-2.866 4.251-15.864.768-2.866a11.867 11.867 0 0 1 8.392-8.392l18.73-5.018a11.867 11.867 0 0 1 11.462 3.071l13.712 13.712a11.867 11.867 0 0 1 3.071 11.463l-.767 2.865-4.251 15.865-.001.003Z",
    fill: "#FFD836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.738 66.125-1.035-3.864 1.035 3.864Zm-18.73 5.019-1.035-3.864 1.035 3.864Zm-11.463-3.072 2.829-2.829-2.829 2.829ZM32.834 54.361l-2.829 2.828 2.829-2.828ZM43.94 12.91l1.036 3.863-1.035-3.864Zm18.73-5.02-1.035-3.863 1.036 3.864Zm11.463 3.072 2.829-2.828-2.829 2.828Zm13.712 13.712-2.829 2.828 2.829-2.828Zm2.303 14.328-3.863-1.035 3.864 1.035Zm-4.25 15.865 3.863 1.035-3.863-1.035Zm-3.865-1.032-.767 2.862 7.727 2.07.767-2.862-7.727-2.07Zm-.767 2.862a7.867 7.867 0 0 1-5.563 5.563l2.07 7.727a15.867 15.867 0 0 0 11.22-11.22l-7.727-2.07Zm-5.563 5.563-18.73 5.019 2.07 7.727 18.73-5.019-2.07-7.727Zm-18.73 5.019a7.867 7.867 0 0 1-7.6-2.037L43.718 70.9a15.867 15.867 0 0 0 15.327 4.107l-2.071-7.727Zm-7.6-2.037-13.71-13.71-5.657 5.656L43.716 70.9l5.658-5.657Zm-13.71-13.71a7.867 7.867 0 0 1-2.037-7.6l-7.727-2.07a15.867 15.867 0 0 0 4.107 15.326l5.656-5.657Zm-2.037-7.6.768-2.866-7.727-2.07-.768 2.865 7.727 2.071Zm.768-2.866 4.25-15.864-7.726-2.07-4.251 15.864 7.727 2.07Zm4.25-15.864.769-2.866-7.728-2.07-.767 2.865 7.727 2.07Zm.769-2.866a7.867 7.867 0 0 1 5.563-5.563l-2.07-7.727a15.867 15.867 0 0 0-11.22 11.22l7.727 2.07Zm5.563-5.563 18.73-5.019-2.07-7.727-18.73 5.019 2.07 7.727Zm18.73-5.019a7.867 7.867 0 0 1 7.6 2.037l5.656-5.657a15.867 15.867 0 0 0-15.327-4.107l2.07 7.727Zm7.6 2.037 13.71 13.711 5.657-5.657L76.962 8.135l-5.657 5.657Zm13.71 13.711a7.867 7.867 0 0 1 2.037 7.6l7.727 2.07a15.867 15.867 0 0 0-4.107-15.327l-5.657 5.657Zm2.037 7.6-.768 2.865 7.727 2.07.768-2.865-7.727-2.07Zm-.768 2.865-4.251 15.864 7.727 2.07 4.251-15.864-7.727-2.07Zm-4.251 15.864v.003h-.001l7.727 2.071v-.001h.001v-.002l-7.727-2.07Z",
    fill: "#000",
    mask: "url(#points-recoup_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.24 68.278a8.9 8.9 0 0 1-8.597-2.304L34.932 52.263a8.9 8.9 0 0 1-2.304-8.597l5.019-18.73a8.9 8.9 0 0 1 6.293-6.294l18.73-5.019a8.9 8.9 0 0 1 8.598 2.304l13.711 13.711a8.9 8.9 0 0 1 2.304 8.597l-5.02 18.73a8.9 8.9 0 0 1-6.293 6.294l-18.73 5.019Z",
    fill: "#FFA63F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.008 71.144a11.868 11.868 0 0 1-11.463-3.072L32.834 54.361a11.867 11.867 0 0 1-3.072-11.463l5.02-18.73a11.867 11.867 0 0 1 8.39-8.392l18.73-5.019a11.867 11.867 0 0 1 11.463 3.072L87.078 27.54a11.867 11.867 0 0 1 3.071 11.463l-5.018 18.73a11.867 11.867 0 0 1-8.392 8.392l-18.73 5.019Zm-7.267-7.268a5.934 5.934 0 0 0 5.731 1.536l18.73-5.019a5.934 5.934 0 0 0 4.196-4.195l5.019-18.73a5.934 5.934 0 0 0-1.536-5.732L69.17 18.025a5.934 5.934 0 0 0-5.732-1.536l-18.73 5.019a5.934 5.934 0 0 0-4.195 4.195l-5.02 18.73a5.934 5.934 0 0 0 1.536 5.732l13.712 13.711Z",
    fill: "#EEB420"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.008 65.412a8.9 8.9 0 0 1-8.597-2.304L35.7 49.397a8.9 8.9 0 0 1-2.304-8.597l5.019-18.73a8.9 8.9 0 0 1 6.293-6.294l18.73-5.019a8.9 8.9 0 0 1 8.598 2.304l13.71 13.711a8.9 8.9 0 0 1 2.305 8.598L83.03 54.1a8.9 8.9 0 0 1-6.293 6.293l-18.73 5.019Z",
    fill: "#FFA63F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.776 68.278a11.867 11.867 0 0 1-11.463-3.072L33.602 51.495a11.867 11.867 0 0 1-3.072-11.463l5.019-18.73a11.867 11.867 0 0 1 8.391-8.392l18.73-5.018a11.867 11.867 0 0 1 11.463 3.071l13.712 13.712a11.867 11.867 0 0 1 3.071 11.463l-5.019 18.73a11.867 11.867 0 0 1-8.39 8.391l-18.731 5.019Zm-7.267-7.268a5.934 5.934 0 0 0 5.731 1.536l18.73-5.018a5.933 5.933 0 0 0 4.196-4.196l5.019-18.73a5.933 5.933 0 0 0-1.536-5.732L69.938 15.16a5.934 5.934 0 0 0-5.732-1.536l-18.73 5.019a5.934 5.934 0 0 0-4.196 4.196l-5.018 18.73a5.934 5.934 0 0 0 1.535 5.731L51.51 61.011Z",
    fill: "#FFD836"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.114 25.865a.417.417 0 0 0-.233.095 7.884 7.884 0 0 1-.07-.052c-.155.148-.152.41.067.569 1.377.993 4.016 2.115 7.155 2.956 3.138.84 5.993 1.189 7.683 1.017.267-.027.4-.25.343-.454a6.595 6.595 0 0 1-.086.01.416.416 0 0 0-.156-.205c-1.363-.989-3.977-2.105-7.087-2.939-3.11-.833-5.941-1.174-7.616-.997Zm16.37 3.387c.203-1.134-3.446-3.068-8.228-4.35-4.783-1.281-8.91-1.43-9.3-.347l-.015-.004a28.544 28.544 0 0 0-4.364 7.842 39.078 39.078 0 0 0 21.78 5.835c.514-2.957.574-5.993.142-8.972l-.015-.005ZM57.155 51.404c4.849 1.3 8.235.881 9.479-.259a28.405 28.405 0 0 0 3.77-6.35 39.077 39.077 0 0 1-21.418-5.739 28.39 28.39 0 0 0 .09 7.384c.18 1.34 3.23 3.665 8.079 4.964Z",
    fill: "#FFD836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.41 58.4 3.189 1.117c.535.19.535.961 0 1.152l-3.188 1.116a1.218 1.218 0 0 0-.745.756l-1.098 3.237a.599.599 0 0 1-1.136 0l-1.098-3.237a1.217 1.217 0 0 0-.745-.756l-3.188-1.116c-.535-.19-.535-.962 0-1.152L12.59 58.4c.347-.125.622-.397.745-.756l1.098-3.238a.599.599 0 0 1 1.136 0l1.098 3.238c.123.352.39.63.745.756ZM99.215 8.944l4.25 1.507c.713.258.713 1.3 0 1.557l-4.25 1.507a1.634 1.634 0 0 0-.993 1.021l-1.465 4.373a.795.795 0 0 1-1.514 0l-1.465-4.373a1.635 1.635 0 0 0-.993-1.02l-4.25-1.508c-.713-.258-.713-1.299 0-1.557l4.25-1.507c.463-.168.83-.535.993-1.021l1.465-4.373a.795.795 0 0 1 1.514 0l1.465 4.373c.163.476.52.853.993 1.021ZM109.607 22.972l2.126.754c.356.129.356.65 0 .778l-2.126.754a.817.817 0 0 0-.496.51l-.733 2.186a.397.397 0 0 1-.756 0l-.733-2.186a.817.817 0 0 0-.496-.51l-2.126-.754c-.356-.129-.356-.65 0-.778l2.126-.754a.818.818 0 0 0 .496-.51l.733-2.187a.397.397 0 0 1 .756 0l.733 2.187c.082.237.26.426.496.51Z",
    fill: "#FFD836"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "points-recoup_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h206v230H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "points-recoup_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-54 -29)",
    d: "M0 0h305v305H0z"
  })))));
};
export default SvgPointsRecoup;